import { NgModule } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module.js';
import { Global404Component } from './global-404.component.js';
import { UnauthorizedComponent } from './unauthorized.component.js';
import { LayoutModule } from "../../layout/layout.module.js";

@NgModule({
    declarations: [Global404Component, UnauthorizedComponent],
    exports: [Global404Component, UnauthorizedComponent],
    imports: [CoreModule, LayoutModule]
})
export class SharedComponentsModule {}
